// extracted by mini-css-extract-plugin
module.exports =  {"container":"_35875ce240--container--Zl3sj","title":"_35875ce240--title--oEV1R","text":"_35875ce240--text--MtYHo"};